import { render, staticRenderFns } from "./foo.vue?vue&type=template&id=aadbed58&scoped=true&"
import script from "./foo.vue?vue&type=script&lang=js&"
export * from "./foo.vue?vue&type=script&lang=js&"
import style0 from "./foo.vue?vue&type=style&index=0&id=aadbed58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadbed58",
  null
  
)

export default component.exports